import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { usePantallaAncha } from '../hooks/use-pantalla-ancha';

/**
 * El resumen al costado de los asistentes de Compite («Tu regla», «Tu
 * estrategia»): lo que se va eligiendo, a la vista en todos los pasos. Sólo en
 * pantallas anchas; en una angosta el paso necesita todo el lugar.
 */
export function ResumenDelAsistente({
  titulo,
  children,
  className,
}: {
  titulo: string;
  children: ReactNode;
  className?: string;
}) {
  const ancha = usePantallaAncha();
  if (!ancha) return null;
  return (
    <aside
      aria-label={titulo}
      className={cn(
        'w-80 shrink-0 space-y-3 overflow-y-auto border-l bg-muted/30 px-5 py-5',
        className
      )}
    >
      <p className="text-sm font-semibold text-foreground">{titulo}</p>
      {children}
    </aside>
  );
}

/** Una línea del resumen: lo elegido, o lo que falta elegir en gris. */
export function FilaDelResumen({
  titulo,
  valor,
  vacio,
}: {
  titulo: string;
  valor: ReactNode | null;
  vacio?: string;
}) {
  return (
    <div className="rounded-lg border bg-card p-3">
      <p className="text-xs font-medium text-muted-foreground">{titulo}</p>
      <p
        className={cn(
          'mt-1 text-sm [overflow-wrap:anywhere]',
          valor ? 'font-semibold text-foreground' : 'text-muted-foreground'
        )}
      >
        {valor ?? vacio}
      </p>
    </div>
  );
}
